<template>
  <v-row
    justify="center"
    align="center"
    v-if="Object.keys(orderInfo).length != 0"
  >
    <v-col cols="12" sm="10" md="10" lg="8" xl="6">
      <v-col align="center">
        <h2 align="center" class="title-underline" translate>
          {{ $t(["REQUEST REFUND"]) }}
        </h2>

        <h3>
          {{ $t(["OrderNumber_Label"]) }}
          {{ orderInfo.orderNumberId }}
        </h3>

        <h3>
          {{ $t(["PhoneNumber_Label"]) }}
          {{ orderInfo.phoneNumber }}
        </h3>
      </v-col>

      <v-alert
        v-model="errorMsgAlert"
        close-text="Close Alert"
        class="alert-text my-5"
        color="error"
        dark
        dismissible
        ref="snackbarError"
      >
        {{ $t(errorMsg) }}
      </v-alert>

      <v-card class="card mb-5" v-show="orderInfo.type != 'RegisterAndDonate'">
        <v-row justify="center" align="center">
          <v-col>
            <h4 align="center" class="my-3" translate>
              {{ $t(["MERCHANDISE SUMMARY"]) }}
            </h4>

            <v-divider class="mx-5"></v-divider>

            <MerchandiseTable
              :orderCart="
                orderInfo.cart != undefined
                  ? Object.values(JSON.parse(orderInfo.cart))
                  : []
              "
            />
          </v-col>
        </v-row>
      </v-card>

      <v-card class="card mb-5">
        <v-row justify="center" align="center">
          <v-col>
            <v-simple-table class="mx-3">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center px-0"></th>
                    <th class="text-center px-0">{{ $t(["Amount"]) }}</th>
                    <th class="text-center px-0">{{ $t(["Refunded"]) }}</th>
                    <th class="text-center px-0">{{ $t(["To Refund"]) }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    class="text-center"
                    v-show="orderInfo.type != 'RegisterAndDonate'"
                  >
                    <td class="px-0">{{ $t(["Merchandise"]) }}</td>
                    <td
                      class="px-0"
                      v-html="
                        $t('Currency', {
                          amount:
                            orderInfo.merchTotal != undefined
                              ? orderInfo.merchTotal.toFixed(2)
                              : (0).toFixed(2),
                        })
                      "
                    />
                    <td
                      class="secondary--text px-0"
                      v-html="
                        '(' +
                        $t('Currency', {
                          amount:
                            orderInfo.refundData.refundAmount.approved.merchandise.toFixed(
                              2
                            ),
                        }) +
                        ')'
                      "
                    />
                    <td class="px-0">
                      <v-text-field
                        :label="$t(['Refund Amount'])"
                        class="centered-input error-field pt-6"
                        ref="merchInput"
                        v-model="merchRefundRequest"
                        :prefix="$i18n.locale == 'en' ? '$' : ''"
                        :suffix="$i18n.locale == 'fr' ? '$' : ''"
                        maxlength="7"
                        :disabled="disableMerchTextfield"
                        :error="merchTextfieldError"
                        :error-messages="merchTextfieldErrorMsg"
                        @blur="maskCurrency"
                        @click="selectAllText('merchInput')"
                        dense
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr class="text-center">
                    <td class="px-0">{{ $t(["Donation"]) }}</td>
                    <td
                      class="px-0"
                      v-html="
                        $t('Currency', {
                          amount:
                            orderInfo.formData.donationAmount != undefined
                              ? orderInfo.formData.donationAmount.toFixed(2)
                              : (0).toFixed(2),
                        })
                      "
                    />
                    <td
                      class="secondary--text px-0"
                      v-html="
                        '(' +
                        $t('Currency', {
                          amount:
                            orderInfo.refundData.refundAmount.approved.donation.toFixed(
                              2
                            ),
                        }) +
                        ')'
                      "
                    />
                    <td class="px-0">
                      <v-text-field
                        :label="$t(['Refund Amount'])"
                        class="centered-input error-field pt-6"
                        ref="donationInput"
                        v-model="donationRefundRequest"
                        :prefix="$i18n.locale == 'en' ? '$' : ''"
                        :suffix="$i18n.locale == 'fr' ? '$' : ''"
                        maxlength="7"
                        :disabled="disableDonationTextfield"
                        :error="donationTextfieldError"
                        :error-messages="donationTextfieldErrorMsg"
                        @blur="maskCurrency"
                        @click="selectAllText('donation')"
                        dense
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr class="text-center">
                    <td class="px-0">
                      <h2>{{ $t(["Total"]) }}</h2>
                    </td>
                    <td class="px-0">
                      <h2
                        v-html="
                          $t('Currency', {
                            amount: Number(orderInfo.formData.amount).toFixed(2),
                          })
                        "
                      />
                    </td>
                    <td class="px-0">
                      <h2
                        class="secondary--text"
                        v-html="
                          '(' +
                          $t('Currency', {
                            amount:
                              orderInfo.refundData.refundAmount.approved.total.toFixed(
                                2
                              ),
                          }) +
                          ')'
                        "
                      />
                    </td>
                    <td class="px-0">
                      <h2
                        v-html="
                          $t('Currency', {
                            amount: (!isNaN(parseFloat(merchRefundRequest)) &&
                            !isNaN(parseFloat(donationRefundRequest)) &&
                            orderInfo.type == 'Merchandise'
                              ? parseFloat(merchRefundRequest) +
                                parseFloat(donationRefundRequest)
                              : !isNaN(parseFloat(donationRefundRequest))
                              ? parseFloat(donationRefundRequest)
                              : 0
                            ).toFixed(2),
                          })
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-col class="py-0">
              <v-divider></v-divider>

              <div class="d-flex flex-wrap justify-center">
                <!-- <div
                placeholder="{{ 'Submit Refund Request' | translate }}"
                ></div>
                <div
                placeholder="{{ 'Update Refund Request' | translate }}"
                ></div> -->
                <v-btn
                  class="btn-text btn-multiline my-5"
                  color="primary"
                  max-width="300px"
                  x-large
                  :loading="requestRefundBtnLoading"
                  @click="submitRequestRefund()"
                >
                  <span class="text-wrap">
                    {{
                      this.orderInfo.refundData.refundRequestId == null
                        ? $t(["Submit Refund Request"])
                        : $t(["Update Refund Request"])
                    }}
                  </span>
                </v-btn>
              </div>

              <div v-show="this.orderInfo.refundData.refundRequestId != null">
                <v-divider class="mx-5"></v-divider>

                <v-row class="py-5 px-3" justify="center" align="center">
                  <v-btn
                    class="btn-text btn-multiline mx-3 my-3"
                    color="secondary"
                    max-width="320px"
                    x-large
                    outlined
                    :loading="withdrawRefundBtnLoading"
                    @click="withdrawRefundRequest()"
                  >
                    <span class="text-wrap" translate>
                      {{ $t(["Withdraw Refund Request"]) }}
                    </span>
                  </v-btn>
                </v-row>
              </div>
            </v-col>
          </v-col>
        </v-row>
      </v-card>

      <v-row justify="center" align="center">
        <v-col cols="10" sm="8" xl="4">
          <v-btn
            class="btn-text btn-multiline mt-5 mt-10"
            x-large
            block
            @click="backToOrderStatusSummary()"
          >
            <span class="text-wrap" translate>
              {{ $t(["Back: Order Details"]) }}
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { Auth } from "aws-amplify";

import { useAuthenicationStore } from "../../store/authenication";
import { useStatusStore } from "../../store/status";
import { useRefundStore } from "../../store/refund";

import MerchandiseTable from "@/app/components/MerchandiseTable.vue";

export default {
  name: "RequestRefund",
  data: () => ({
    orderInfo: {},
    total: 0,
    requestRefundBtnLoading: false,
    withdrawRefundBtnLoading: false,
    errorMsgAlert: false,
    errorMsg: "",
    merchTextfieldError: false,
    merchTextfieldErrorMsg: "",
    donationTextfieldError: false,
    donationTextfieldErrorMsg: "",
    merchRefundRequest: 0,
    donationRefundRequest: 0,
    validMerchRefundRequest: 0,
    validDonationRefundRequest: 0,
    disableMerchTextfield: false,
    disableDonationTextfield: false,
  }),
  components: {
    MerchandiseTable,
  },
  setup() {
    const authStore = useAuthenicationStore();
    const statusStore = useStatusStore();
    const refundStore = useRefundStore();

    return {
      authStore,
      statusStore,
      refundStore,
    };
  },
  mounted() {
    this.orderInfo =
      Object.keys(this.$route.params).length != 0
        ? this.$route.params.data
        : this.statusStore.orderData;

    this.statusStore.setOrderData(this.orderInfo);

    this.total =
      this.orderInfo.merchTotal + this.orderInfo.formData.donationAmount;

    if (this.orderInfo.merchTotal > 0) {
      this.merchRefundRequest =
        Object.keys(this.orderInfo.refundData.refundAmount.pending).length != 0
          ? this.orderInfo.refundData.refundAmount.pending.merchandise.toFixed(
              2
            )
          : this.merchRefundRequest.toFixed(2);
    }
    this.donationRefundRequest =
      Object.keys(this.orderInfo.refundData.refundAmount.pending).length != 0
        ? this.orderInfo.refundData.refundAmount.pending.donation.toFixed(2)
        : this.donationRefundRequest.toFixed(2);

    if (
      this.orderInfo.merchTotal -
        this.orderInfo.refundData.refundAmount.approved.merchandise ==
      0
    ) {
      this.disableMerchTextfield = true;
    }

    if (
      this.orderInfo.formData.donationAmount -
        this.orderInfo.refundData.refundAmount.approved.donation ==
        0 ||
      this.orderInfo.formData.donationAmount == undefined
    ) {
      this.disableDonationTextfield = true;
    }
  },
  watch: {
    "$i18n.locale"() {
      this.merchTextfieldError = false;
      this.merchTextfieldErrorMsg = "";

      this.donationTextfieldError = false;
      this.donationTextfieldErrorMsg = "";
    },
    merchRefundRequest(amount) {
      if (amount != "" && this.validCurrency(amount)) {
        this.validMerchRefundRequest = parseFloat(amount);
      } else {
        this.validMerchRefundRequest = (0).toFixed(2);
      }
    },
    donationRefundRequest(amount) {
      if (amount != "" && this.validCurrency(amount)) {
        this.validDonationRefundRequest = parseFloat(amount);
      } else {
        this.validDonationRefundRequest = (0).toFixed(2);
      }
    },
  },
  methods: {
    validCurrency(amount) {
      let currencyRegex =
        /^\$?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$/;

      return currencyRegex.exec(amount);
    },
    maskCurrency() {
      this.merchRefundRequest = parseFloat(
        this.validMerchRefundRequest
      ).toFixed(2);
      this.donationRefundRequest = parseFloat(
        this.validDonationRefundRequest
      ).toFixed(2);
    },
    async submitRequestRefund() {
      this.requestRefundBtnLoading = true;

      if (this.checkValidRefund()) {
        try {
          await Auth.currentSession().then(async (data) => {
            await this.refundStore
              .requestRefundApi(
                {
                  eventName: this.authStore.runSiteInfo.eventName,
                  orderId: this.orderInfo.id,
                  refundInfo: {
                    dt: new Date(),
                    amount: {
                      merchandise: parseFloat(this.merchRefundRequest),
                      donation: parseFloat(this.donationRefundRequest),
                      total:
                        this.orderInfo.type == "Merchandise"
                          ? parseFloat(this.merchRefundRequest) +
                            parseFloat(this.donationRefundRequest)
                          : parseFloat(this.donationRefundRequest),
                    },
                    status: "Pending",
                    orderId: this.orderInfo.id,
                    orderNumberId: this.orderInfo.orderNumberId,
                  },
                },
                data.idToken.jwtToken
              )
              .then((response) => {
                // console.log(response);

                if (response.success) {
                  this.goToOrderStatus();
                  return;
                } else {
                  throw response.message;
                }
              });
          });
        } catch (error) {
          this.errorMsgAlert = true;
          this.errorMsg = error.message == undefined ? error : error.message;

          this.$nextTick(() => {
            const el = this.$el.querySelector("snackbarError");
            this.$vuetify.goTo(-5, el);

            return;
          });
        }
      }

      this.requestRefundBtnLoading = false;
    },
    async withdrawRefundRequest() {
      this.withdrawRefundBtnLoading = true;

      try {
        await Auth.currentSession().then(async (data) => {
          await this.refundStore
            .updateRefundStatusApi(
              {
                eventName: this.authStore.runSiteInfo.eventName,
                orderId: this.orderInfo.id,
                refundInfo: {
                  closed: new Date(),
                  status: "Withdrawn",
                  refundId: this.orderInfo.refundData.refundRequestId,
                },
              },
              data.idToken.jwtToken
            )
            .then((response) => {
              // console.log(response);

              if (response.success) {
                this.goToOrderStatus("Withdrawn");
                return;
              } else {
                throw response.message;
              }
            });
        });
      } catch (error) {
        this.errorMsgAlert = true;
        this.errorMsg = error.message == undefined ? error : error.message;

        this.$nextTick(() => {
          const el = this.$el.querySelector("snackbarError");
          this.$vuetify.goTo(-5, el);

          return;
        });
      }

      this.withdrawRefundBtnLoading = false;
    },
    checkValidRefund() {
      let totalRefundAmount =
        parseInt(this.merchRefundRequest) +
        parseInt(this.donationRefundRequest);

      let maxDonationRefund =
        this.orderInfo.formData.donationAmount -
        this.orderInfo.refundData.refundAmount.approved.donation;

      if (this.donationRefundRequest > maxDonationRefund) {
        this.donationTextfieldError = true;
        this.donationTextfieldErrorMsg = this.$t([
          "Refund amount exceeds refundable total",
        ]);
      } else if (
        isNaN(this.donationRefundRequest) ||
        (maxDonationRefund > 0 &&
          this.donationRefundRequest == 0 &&
          totalRefundAmount == 0)
      ) {
        this.donationTextfieldError = true;
        this.donationTextfieldErrorMsg = this.$t(["Invalid refund amount"]);
      } else {
        this.donationTextfieldError = false;
        this.donationTextfieldErrorMsg = "";
      }

      let maxMerchRefund =
        this.orderInfo.merchTotal -
        this.orderInfo.refundData.refundAmount.approved.merchandise;

      if (this.merchRefundRequest > maxMerchRefund) {
        this.merchTextfieldError = true;
        this.merchTextfieldErrorMsg = this.$t([
          "Refund amount exceeds refundable total",
        ]);
      } else if (
        isNaN(this.merchRefundRequest) ||
        (maxMerchRefund > 0 &&
          this.merchRefundRequest == 0 &&
          totalRefundAmount == 0)
      ) {
        this.merchTextfieldError = true;
        this.merchTextfieldErrorMsg = this.$t(["Invalid refund amount"]);
      } else {
        this.merchTextfieldError = false;
        this.merchTextfieldErrorMsg = "";
      }

      if (this.merchTextfieldError || this.donationTextfieldError) {
        return false;
      }

      return true;
    },
    selectAllText(input) {
      let element =
        input == "merchInput"
          ? this.$refs.merchInput.$el.querySelector("input")
          : this.$refs.donationInput.$el.querySelector("input");

      this.$nextTick(() => {
        element.select();
      });
    },
    goToOrderStatus(refundStatus) {
      localStorage.removeItem("status");

      this.$router.replace({
        name: "OrderStatus",
        params: {
          success: true,
          message:
            refundStatus == "Withdrawn"
              ? this.$gettext("Successfully withdrawn refund request")
              : this.orderInfo.refundData.refundRequestId != null
              ? this.$gettext("Successfully updated refund request")
              : this.$gettext("Successfully submitted refund request"),
        },
      });
    },
    backToOrderStatusSummary() {
      let data = this.$route.params.data;

      this.$router.push({
        name: "OrderStatusSummary",
        params: { data },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  width: 50px !important;
}

// Center error message
div ::v-deep .v-messages {
  text-align: center;
}
</style>
